import { React } from 'react';

const DealsCallout = () => {
  return (
    <div className="deals-callout-container">
      <h2 className="deals-callout">
        Check out our latest <span className="deals"> deals </span>
        <span className="arrow">&#x2935;</span>
      </h2>
    </div>
  );
};

export default DealsCallout;
